<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">材料入库</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form label-width="130px" class="form">
          <el-form-item label="所属仓库">
            <el-col :span="10">
              <el-select size="small" @change="forceUpdate" class="organization-select" v-model="form.houseId"
                :disabled="isWz?true:false" placeholder="请选择仓库">
                <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
            <!-- <router-link class="material-in-link" to="/Storage/Room/List">添加仓库</router-link> -->
          </el-form-item>
          <el-form-item label="供应商">
            <el-col :span="10">
              <el-select size="small" @change="forceUpdate" class="organization-select" v-model="form.supplierId"
                placeholder="请选择供应商">
                <el-option v-for="item in supplierList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
            <router-link class="material-in-link" to="/Storage/SupplierList/1">添加供应商</router-link>
          </el-form-item>
          <el-form-item label="发票号码">
            <el-col :span="10">
              <el-input size="small" v-model="form.inVoice"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="入库时间">
            <el-date-picker v-model="form.time" :disabled="isWz?true:false" style="width:200px!important;" size="small"
              value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择材料入库时间">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="材料明细">
            <section class="material-list">
              <div class="list-title">
                <div class="r">
                  <el-button @click="AddMaterial()" type="primary" size="mini">添加材料</el-button>
                </div>
              </div>
              <div class="material-table">
                <el-table :data="form.materials" border>
                  <el-table-column prop="material.number" width="90" label="材料编号">
                  </el-table-column>
                  <el-table-column prop="material.name" width="240" label="明细名称">
                  </el-table-column>
                  <!-- 
                  <el-table-column prop="spec" label="规格型号">
                  </el-table-column> -->
                  <el-table-column prop="material.unit.name" align="center" label="计量单位">
                  </el-table-column>
                  <el-table-column prop="" align="center" label="数量">
                    <template slot-scope="scope">
                      {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="" align="center" label="单价">
                    <template slot-scope="scope">
                      {{ scope.row.price && parseFloat(scope.row.price).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="" align="center" label="总价">
                    <template slot-scope="scope">
                      {{ scope.row.totalPrice && parseFloat(scope.row.totalPrice).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="点击变更信息" placement="bottom">
                        <i @click="MaterialChange(scope.row, scope.$index)"
                          class="iconfont icon-xiugai meeting-btn-icon  mbi-edit"></i>
                      </el-tooltip>
                      <el-tooltip class="item" v-if="!isWz" effect="dark" content="点击删除" placement="bottom">
                        <i @click="MaterialDelete(scope.$index)"
                          class="iconfont icon-close meeting-btn-icon mbi-remove"></i>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="pay-status">
                <span class="pay-status-item">总价：{{ form.total }}元</span>
              </div>
            </section>
          </el-form-item>

          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitMaterial()" class="form-btn" type="success">确认提交材料入库单
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>

    <!-- 添加材料 -->
    <div class="pop-room" v-if="addStatus">
      <a href="javascript:;" @click="addStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="mform" label-width="120px" class="form">
            <el-form-item label="*明细名称">
              <el-select size="small" style="width:100%" filterable v-model="mform.materialId" placeholder="支持搜索"
                :disabled="(isWz && mform.materialId)?true:false">
                <el-option v-for="item in materialList" :key="item.id"
                  :label="item.number+' - '+item.name+' ('+item.dl.name+') ('+item.spec+')'" :value="item.id">
                </el-option>
              </el-select>
              <!-- <el-input size="small" v-model="mform.name"></el-input> -->
            </el-form-item>
            <el-form-item label="*数量">
              <el-input size="small" placeholder="材料数量" type="number" v-model="mform.amount"></el-input>
            </el-form-item>
            <el-form-item label="单价(元)">
              <el-input size="small" :disabled="!inId" placeholder="数量入库时允许为空" type="number" v-model="mform.price">
              </el-input>
            </el-form-item>
            <el-form-item label="总价(元)">
              <el-input size="small" type="number" :disabled="true" v-model="mform.totalPrice"></el-input>
            </el-form-item>

            <el-form-item label="">
              <el-button @click="AddBtnClick()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
    <div class="pop-room-bg" v-if="addStatus"></div>

  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
        managerStorage: state => state.storage.managerStorage,
      })
    },
    data() {
      return {
        formLoading: false,
        organizationListData: [],
        noSelectOrganization: true,

        houseList: '',
        supplierList: '',
        unitList: '',
        materialList: '',
        isWz: 0,

        form: {
          houseId: '',
          inVoice: '',
          supplierId: '',
          total: 0,
          time: '',
          materials: [],
          json: true,
        },
        inId: '',

        addType: 0,
        editIndex: '',
        mform: {
          materialId: '',
          amount: '',
          price: '',
          totalPrice: '',
        },

        depId: '',
        addStatus: false,
      }
    },
    created() {
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.$route.params.houseId) {
        this.form.houseId = this.$route.params.houseId / 1
      }

      if (this.$route.query.inId) {
        // 编辑入库
        this.inId = this.$route.query.inId
        this.isWz = this.$route.query.wz
        // 获取入库信息
        ajax.get('/storage/material/in/detail', {
          inId: this.inId
        }, (res) => {
          this.form = res.vo
          this.form.houseId = this.form.house.id / 1
          this.form.supplierId = this.form.supplier ? this.form.supplier.id / 1 : ''
          this.form.json = true

          let _materials = this.form.materials
          for (var i = 0; i < _materials.length; i++) {
            let _tmp = {},
              _item = _materials[i]
            _tmp.number = _item.number
            _tmp.name = _item.name
            _tmp.unit = {
              id: _item.unitId,
              name: _item.unitName
            }
            _tmp.materialId = _item.materialId
            _item.material = _tmp
          }
        })
      }


      this.form.time = this.getNowTime()

      this.getHouseList()
      this.getSupplierList()
      this.getUnitList()
      // this.getMaterialList()
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      plusZero(s) {
        return s < 10 ? '0' + s : s;
      },
      getNowTime() {
        let _s = ""
        let _time = new Date()
        _s += _time.getFullYear() + "-"
        _s += this.plusZero(_time.getMonth() + 1) + "-"
        _s += this.plusZero(_time.getDate()) + " "
        _s += this.plusZero(_time.getHours()) + ":"
        _s += this.plusZero(_time.getMinutes()) + ":"
        _s += "00"
        return _s
      },
      // 提交材料入库单
      SubmitMaterial() {
        if (!this.form.houseId) {
          this.$message.error("请选择入库材料的所属仓库")
          return
        }
        if (!this.form.time) {
          this.$message.error("请选择入库时间")
          return
        }

        let _url = '/storage/material/in'
        if (this.inId) {
          _url = '/storage/material/in/edit/item?inId=' + this.inId
        }
        ajax.post(_url, this.form, (res) => {
          this.loading = false
          this.$message.success("提交成功")

          this.$router.push('/Storage/MaterialInList/' + this.form.houseId)
        })
      },
      // 编辑材料
      MaterialChange(row, index) {
        this.addType = 1
        this.editIndex = index
        this.mform = row
        this.addStatus = true
      },
      // 从列表里删除当前材料
      MaterialDelete(index) {
        // console.log(index)
        this.form.materials.splice(index, 1)
      },
      // 显示添加材料弹窗
      AddMaterial() {
        this.isWz = false
        this.mform = {
          materialId: '',
          amount: '',
          price: '',
          totalPrice: '',
        }
        this.addType = 0
        this.addStatus = true
      },
      // 添加材料到列表
      AddBtnClick() {
        if (!this.mform.materialId || !this.mform.amount) {
          this.$message.error("请认真填写材料信息，带*为必填项")
          return
        }
        this.mform.material = this.materialList.find((obj) => {
          return obj.id == this.mform.materialId
        })
        console.log(this.mform)
        if (this.addType == 0) {
          this.form.materials.push(this.mform)
        } else {
          this.form.materials.splice(this.editIndex, 1, this.mform)
        }

        let _total = 0
        for (var i = 0; i < this.form.materials.length; i++) {
          if (this.form.materials[i].totalPrice) {
            _total += parseFloat(this.form.materials[i].totalPrice)
          }
        }
        this.form.total = _total.toFixed(2)

        // 初始化
        this.mform = {
          materialId: '',
          amount: '',
          price: '',
          totalPrice: '',
        }
        this.addStatus = false
      },
      // 获得计量单位名称
      getUnitName(unitId) {
        for (var i = 0; i < this.unitList.length; i++) {
          let _item = this.unitList[i]
          if (unitId == _item.id) {
            return _item.name
          }
        }
      },
      // 获取材料基础资料列表
      getMaterialList() {
        ajax.get('/storage/material/orderby/stock/list', {
          // houseId: this.form.houseId
        }, (res) => {
          this.loading = false
          this.materialList = res.vo.array
        })
      },
      // 获取仓库列表
      getHouseList() {
        // 只允许有管理权限的仓库录入
        this.houseList = this.managerStorage
        // ajax.get('/storage/house/list', {
        //   'depId': this.depId
        // }, (res) => {
        //   console.log(res.vo.array)
        //   this.houseList = res.vo.array
        //   this.houseList = util.arrConcatUnRepeat(this.houseList, this.managerStorage)

        //   console.log(this.managerStorage)
        // })
      },
      // 获取供应商列表
      getSupplierList() {
        ajax.get('/supplier/list', {
          'type': 1
        }, (res) => {
          this.loading = false
          this.supplierList = res.vo.array
        })
      },
      // 获取计量单位列表
      getUnitList() {
        ajax.get('/storage/unit/list', '', (res) => {
          this.loading = false
          this.unitList = res.vo.array
        })
      },
    },
    watch: {
      'mform.price'() {
        if (this.mform.price && this.mform.amount) {
          this.mform.totalPrice = (this.mform.price * this.mform.amount).toFixed(2)
        }
      },
      'mform.amount'() {
        if (this.mform.price && this.mform.amount) {
          this.mform.totalPrice = (this.mform.price * this.mform.amount).toFixed(2)
        }
      },
      'form.houseId'() {
        this.getMaterialList()
      },
      'addStatus'(){
        if(!this.addStatus){
          this.isWz = this.$route.query.wz
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/page/storage/materialIn.vue